module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"split__left\">\n    ")
    ; 
    var createEnabled = Util.isFunction(widget.createEnabled)
            ? !!widget.createEnabled()
            : !!widget.createEnabled;
    
    ; __append("\n\n    ")
    ;  if (createEnabled) { 
    ; __append("\n    <div class=\"\" title=\"Создать\" on-click=\"onItemCreateClick\"><a href=\"javascript:void(0);\">+ Создать</a></div>\n    ")
    ;  } 
    ; __append("\n</div>\n<div class=\"split__right\">\n    <div name=\"gridview-pages\" class=\"gridview-pages\"></div>\n    <div class=\"label\">Страницы:&nbsp;</div>\n    <div class=\"count\">\n        Всего: <span name=\"gridview-count\">")
    ; __append(escapeFn( widget.gridCount ))
    ; __append("</span>\n    </div>\n</div>\n")
  }
  return __output.join("");

}